import React from 'react';
import PitchDeckPDF from './familyandfriendsinvestors.pdf';
import AllPagesPDFViewer from "../../components/pdf/all-pages";
import './pitchdeck.css';

export default function Test() {
    return (
        <AllPagesPDFViewer pdf={PitchDeckPDF}/>
    );
}